export default "__VITE_ASSET__C$jxjD$1__"